var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Contains components to render a ColorCell inside the MeasurementsTable.
 */
import React, { useRef, useState, useCallback, Suspense } from "react";
import { Popout, IndeterminateLoadingIndicator, } from "@insync-stageplayer/ui-components";
import styled from "styled-components";
import useClickAway from "react-use/lib/useClickAway";
import useDebounce from "react-use/lib/useDebounce";
/**
 * A lazily loaded component. The ColorPicker uses an external library which is quite big.
 * So we want to use React.lazy so that we can split up the code in webpack.
 */
const LoadingColorPicker = React.lazy(() => import("./ColorPicker"));
/**
 * Will display a loading indicator while we're lazily loading ColorPicker.
 * @param props
 * @returns
 */
const LoadableColorPicker = (props) => {
    return (React.createElement(Suspense, { fallback: React.createElement(IndeterminateLoadingIndicator, null, "Loading...") },
        React.createElement(LoadingColorPicker, Object.assign({}, props))));
};
const StyledDiv = styled.div `
  height: 1em;
  width: 1em;
  border-radius: 0.2em;
  cursor: pointer;
  background-color: ${(props) => props.color ? props.color : props.theme.colors.action.active};
`;
/**
 * Displays a color input inside MeasurementsTable. Will display a color picker when clicked.
 * @param props
 * @returns
 */
export const ColorCell = (props) => {
    const { color, onChange, onChangeColorPickerVisibility, showColorPicker } = props, rest = __rest(props, ["color", "onChange", "onChangeColorPickerVisibility", "showColorPicker"]);
    const pickerRef = useRef(null);
    const [changedColor, setChangedColor] = useState(undefined);
    const handleColorChange = useCallback((v) => {
        setChangedColor(v.hex);
    }, []);
    useClickAway(pickerRef, () => {
        onChangeColorPickerVisibility(false);
    });
    // Debounce the onChange callback, otherwise might result in many unneccesary rerenders.
    useDebounce(() => {
        if (changedColor && onChange) {
            onChange && onChange(changedColor);
        }
    }, 250, [changedColor]);
    return (React.createElement(Popout, { content: React.createElement("div", { ref: pickerRef },
            React.createElement(LoadableColorPicker, { onChange: handleColorChange, disableAlpha: true, color: changedColor || color })), visible: showColorPicker }, ({ ref: popoutRef }) => (React.createElement(StyledDiv, Object.assign({ ref: popoutRef, color: changedColor || color, tabIndex: 0, role: "button", "aria-pressed": "false", onFocus: () => onChangeColorPickerVisibility(true) }, rest)))));
};
//# sourceMappingURL=ColorCell.js.map